import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Loan, Parameter, ClaimLevel, PeriodTypeEnum, LoanListItem } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { LogicService } from '../../../services/logic.service';
import { PendingLoanRequestLogicService } from '../../../services/pending-loan-request-logic.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { UiService } from '../../../services/ui.service';
import { MatSelectChange, MatSnackBar } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-loans-waiting-list',
  templateUrl: './loans-waiting-list.component.html',
  styleUrls: ['./loans-waiting-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoansWaitingListComponent implements OnInit {

  excelFile: File;
  currentWorkBookSheet = 0;
  excelFields = ['ID Ciclo', 'ID Empleado', 'Nombre Empleado', 'Fecha De Solicitud', 'Importe', 'Cuotas', 'Forma De Pago', 'Ahorrador', 'Tipo De Trabajo'];
  savingAccount: Array<any> = [{ title: 'Ahorrador', value: true }, { title: 'No Ahorrador', value: false }];
  selectedSavingAccount: boolean = true;
  displayedColumns: string[] = ['listIndex', 'employeeNumber', 'username', 'requestedAmount', 'requestedNumberOfPayments', 'approvedAt'];
  displayedDeniedColumns: string[] = ['listIndex', 'employeeNumber', 'requestedAmount', 'requestedNumberOfPayments', 'approvedAt'];
  pendingList: Array<LoanListItem> = new Array<LoanListItem>();
  approvedPendingListSubscription: Subscription;
  selectedList: Array<LoanListItem> = new Array<LoanListItem>();
  periodToEdit: Parameter;
  deniedList: Array<LoanListItem> = new Array<LoanListItem>();
  deniedListSubscription: Subscription;
  //////////////////////////////////
  //////////////////////////////////

  period: Parameter;
  periods: Array<Parameter> = Array<Parameter>();
  appLogicChangesSubscription: Subscription = null;
  loading = false;
  currentCount = 0;
  //////////////////////////////////
  //////////////////////////////////

  loanTypes: Array<any> = new Array<any>();
  selectedType: any = null;

  ////////////////////

  constructor(public logicService: LogicService, private pendingLoans: PendingLoanRequestLogicService, private authService: AuthenticationService, private UI: UiService, public snackBar: MatSnackBar) {

  }

  ngOnInit() {

    this.doSubscriptions();

  }

  selectedPeriodChange(event: MatSelectChange) {

    console.log('event', event.value);

    if (!event.value) {
      this.selectedType = null;
      this.selectedList = new Array<LoanListItem>();
    } else {

      this.selectedType = event.value;
      this.selectedList = this.pendingLoans.approvedPendingList.filter(aLoan => {

        if (this.selectedType.parametersID === aLoan.parametersID && aLoan.employeeRef.activeSavingAccount === this.selectedSavingAccount) {

          this.period = this.selectedType;
          // sandra console.log('this.periods', this.period);

          if (this.period) {
            return true;
          }

        }

        return false;

      }).sort((c1, c2) => c1.listIndex - c2.listIndex);
    }

  }
  /**
   * Funcion par adetectar el cambio del selector si el colaborador es ahorrador o no
   * @param event tipo de ahorrador
   */
  selectedSaving(event: MatSelectChange) {

    if (event && this.selectedType) {
      this.selectedSavingAccount = event.value;
      this.selectedList = this.pendingLoans.approvedPendingList.filter(aLoan => {

        if (this.selectedType.parametersID === aLoan.parametersID && aLoan.employeeRef.activeSavingAccount === event.value) {
          this.period = this.selectedType.parametersID;
          if (this.period) {
            return true;
          }
        }

        return false;

      }).sort((c1, c2) => c1.listIndex - c2.listIndex);
      // this.loadData(true);
    }
  }

  get isUserAdmin(): boolean {
    const result = this.authService.appLevel.currentClaim === ClaimLevel.administrator || this.authService.appLevel.currentClaim === ClaimLevel.akiba;
    return result;
  }

  /* get periodHasMoney(): boolean {
 
     if (this.period) {
       return this.selectedList.length > 0 ? this.period.investmentParameterNonSavers.theoreticalAvailableAmount > 0 || this.period.investmentParameterSavers.theoreticalAvailableAmount > 0  : false;
     }
 
     return false;
 
   }*/

  async doSubscriptions() {

    this.cancelSubscriptions();

    this.appLogicChangesSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(c => {

      if (!c.response) {
        return;
      }
      if (this.logicService.dataManager.parameterDataLoader.parameters && this.logicService.dataManager.parameterDataLoader.parameters.length) {

        this.periods = this.logicService.dataManager.parameterDataLoader.parameters.filter(element => {
          //solo permanente
          if (element.type === PeriodTypeEnum.permanentSaving) {
            return true;
          }
          return false;
        });

        this.loadData(false);

      }

    });

    this.approvedPendingListSubscription = this.pendingLoans.approvedPendingListSubject.subscribe(async loanList => {

      if (loanList.length > 0) {

        let snackBarRef = this.snackBar.open('Nuevos préstamos han sido aprobados.', 'Cargar', {
          duration: 5000,
          panelClass: ['green-snackbar']
        });

        snackBarRef.onAction().subscribe(() => {
          this.loadData(true);
        });

        this.currentCount = loanList.length;

      }

      this.logicService.dataManager.parameterDataLoader.load();


    });

    await this.pendingLoans.loadAllApprovedPendingLoans();

  }

  async loadData(refresh: boolean = false) {


    if (this.pendingLoans.approvedPendingList.length === 0 || refresh === true) {

      this.pendingLoans.approvedPendingList = new Array<LoanListItem>();

      const snackBar = this.snackBar.open('Cargando...', null, {
        panelClass: ['green-snackbar']
      });

      snackBar.dismiss();

    }

    this.pendingList = this.pendingLoans.approvedPendingList;

    this.loanTypes = new Array<any>();

    this.periods.forEach(element => {
      this.loanTypes.push(element.title);
    });

    if (this.selectedType) {

      this.selectedList = this.pendingLoans.approvedPendingList.filter(aLoan => {

        if (this.selectedType.parametersID === aLoan.parametersID && aLoan.employeeRef.activeSavingAccount === this.selectedSavingAccount) {
          this.period = this.selectedType.parametersID;

          if (this.period) {
            return true;
          }
        }

        return false;

      }).sort((c1, c2) => c1.listIndex - c2.listIndex);
    }

  }

  cancelSubscriptions() {

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
    }

    if (this.approvedPendingListSubscription && !this.approvedPendingListSubscription.closed) {
      this.approvedPendingListSubscription.unsubscribe();
    }

    if (this.deniedListSubscription && !this.deniedListSubscription.closed) {
      this.deniedListSubscription.unsubscribe();
    }

    // this.pendingLoans.approvedPendingList.splice(0, this.pendingLoans.approvedPendingList.length);
    // this.pendingLoans.stopAllListeners();

  }

  ngOnDestroy(): void {
    this.cancelSubscriptions();
  }

}
